export enum ReservationTypes {
  Foglalva = 1,
  Felszabaditva = 2,
  Tulajdonose = 3,
  Senkie = 4,
}
